import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  CrossMerchantAnalytics,
  GetCrossMerchantAnalyticsParams,
} from "../../interfaces/crossMerchantAnalytics.interface";

export async function getCrossMerchantAnalyticsFromServer(
  params?: GetCrossMerchantAnalyticsParams
): Promise<CrossMerchantAnalytics> {
  const axios = await getTokenizedAxios();
  const path = "/businesses/cross-merchant-analytics";
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + path, { params })
    .then((data) => data?.data);
}

